import React from 'react';
import './Ourservice.css';
import '../style.css';
function Services({ darkMode }) {
  const services = [
    { icon: 'bi-car-front-fill', title: ' Raw Setup', description: ' ' },
    { icon: 'bi-shield-check', title: 'Approved Vehicle Verifier', description: '' },
     { icon: 'bi-table', title: ' Produce Model Report & VASS Engineers Report', description: '' },
   { icon: 'bi-diagram-3', title: ' Business Automation', description: '' }, 
  ];

  return (
    
    <div className="container-fluid text-center heading-title  shadow" style={{ backgroundColor: '#eef2f7'}}>
    
       <h1 className="text-center mb-4 heading-title fw-bold">What we offer</h1>
      <div className="row justify-content-center">
       
        {services.map((service, index) => (
          <div className="col-md-3 mb-4" key={index}>
            <div className="service-card">
              <div className="d-flex flex-column align-items-center">

              <i className={`bi ${service.icon} service-icon mb-4 text-success`} ></i>
              <h5 className='text-body'>{service.title}</h5>
              <p><small className="text-muted fs-6">{service.description}</small></p>
            </div>
          </div>
          </div>
        ))}
      </div>
    </div>
    
  );
}
export default Services;